"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _prepareChildKeys2 = _interopRequireDefault(require("./prepareChildKeys"));

var _pop = _interopRequireDefault(require("unmutable/lib/pop"));

var _default = function _default() {
  return function (parcelData) {
    var _prepareChildKeys = (0, _prepareChildKeys2["default"])()(parcelData),
        value = _prepareChildKeys.value,
        child = _prepareChildKeys.child,
        rest = (0, _objectWithoutProperties2["default"])(_prepareChildKeys, ["value", "child"]);

    return (0, _objectSpread2["default"])({}, rest, {
      value: (0, _pop["default"])()(value),
      child: (0, _pop["default"])()(child)
    });
  };
};

exports["default"] = _default;